import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import SiteLayout from "@/SiteLayout";
import { CmsContentProvider } from "@/content/CmsContentContext";
import AdminEditor from "@/admin/AdminEditor";
import AdminLogin, { AdminGateway, RequireAdmin } from "@/admin/AdminLogin";

const PublicSite = () => (
  <CmsContentProvider>
    <SiteLayout />
  </CmsContentProvider>
);

const ProtectedEditor = () => (
  <RequireAdmin>
    <AdminEditor>
      <SiteLayout routePrefix="/admin/edit" />
    </AdminEditor>
  </RequireAdmin>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AdminGateway />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/edit/*" element={<ProtectedEditor />} />
          <Route path="*" element={<PublicSite />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
